import { t } from "i18next";
export default t;



// WEBPACK FOOTER //
// ./src/utils/t.ts